module.exports = __webpack_public_path__ + "img/FN.80dc2b6f.png";